module.exports = __webpack_public_path__ + "5e8c18c4dadab12a2ce10c8ee064aee3.png";